export type ModalStage =
	| 'Sellers to contact failed to load'
	| 'Loading sellers to contact'
	| 'No sellers to contact'
	| 'Seller contact selection'
	| 'Create email'
	| 'Mark as contacted confirmation'
	| 'Processing - Mark as contacted'
	| 'Processing - Sending emails'
	| 'Results'
	| 'Error - Sending emails'
	| 'Error - Mark as contacted';

export const ModalStepsToStageMap = {
	EmailEditor: 'Create email',
	EnquirySelection: 'Seller contact selection',
	EnquirySelectionError: 'Sellers to contact failed to load',
	EnquirySelectionLoading: 'Loading sellers to contact',
	MarkAsContactedConfirmation: 'Mark as contacted confirmation',
	MarkAsContactedError: 'Error - Mark as contacted',
	MarkAsContactedLoading: 'Processing - Mark as contacted',
	NothingToSend: 'No sellers to contact',
	ProcessingEmails: 'Processing - Sending emails',
	ProcessingEmailsError: 'Error - Sending emails',
} as const;
